/**
 * mSTEM mock SmartHome kits (DG-13/DG-14). Used as the seed for kitsReducer
 * initial state. BE team will replace with a real kit inventory endpoint.
 *
 * Each entry: {id, name, sensorCount, relayCount, hasRFID, image, brand, ...detail}
 *   id          — kebab-case slug, primary key
 *   name        — display name, brand-fixed (not translated)
 *   sensorCount — number of sensors bundled (temp, humidity, light, etc.)
 *   relayCount  — number of relay channels for actuators
 *   hasRFID     — boolean, kit includes MFRC522 RFID reader module
 *   image       — null until DFT provides product photos (DG-21)
 *   brand       — manufacturer string
 *
 * SMH-04 detail block (kit info + firmware view, mirrors robots.js metadata):
 *   model            — commercial model code printed on the enclosure
 *   mcu              — main controller chip
 *   hardwareRevision — PCB revision string
 *   serialNumber     — per-unit serial, primary key on the BE side later
 *   macAddress       — Wi-Fi MAC of the kit hub
 *   ipAddress        — last known LAN address ('' when never connected)
 *   firmwareVersion  — semver-ish string; version currently flashed
 *   connectionStatus — one of 'connected' | 'offline' | 'outdated'
 *   activatedAt      — ISO YYYY-MM-DD activation date
 *   lastSyncAt       — last successful sync, 'YYYY-MM-DD HH:mm' (static mock —
 *                      NEVER Date.now(), keeps snapshots/tests deterministic)
 */

const KITS = [
    {
        id: 'mbf-home-starter',
        name: 'MBF Home Starter Kit',
        sensorCount: 2,
        relayCount: 2,
        hasRFID: false,
        image: null,
        brand: 'MBF SmartHome',
        model: 'MBF-HS-100',
        mcu: 'ESP32-WROOM-32',
        hardwareRevision: 'Rev B',
        serialNumber: 'HS100-2026-0001',
        macAddress: 'B4:E6:2D:1A:00:11',
        ipAddress: '192.168.1.21',
        firmwareVersion: '1.2.0',
        connectionStatus: 'connected',
        activatedAt: '2026-02-18',
        lastSyncAt: '2026-07-24 08:15'
    },
    {
        id: 'mbf-classroom-sensor-pack',
        name: 'MBF Classroom Sensor Pack',
        sensorCount: 5,
        relayCount: 0,
        hasRFID: false,
        image: null,
        brand: 'MBF SmartHome',
        model: 'MBF-CS-200',
        mcu: 'ESP32-S3',
        hardwareRevision: 'Rev A',
        serialNumber: 'CS200-2026-0042',
        macAddress: 'B4:E6:2D:1A:00:2F',
        ipAddress: '192.168.1.34',
        firmwareVersion: '2.0.1',
        connectionStatus: 'connected',
        activatedAt: '2026-03-05',
        lastSyncAt: '2026-07-25 07:40'
    },
    {
        id: 'mbf-security-demo',
        name: 'MBF Security Demo Kit',
        sensorCount: 3,
        relayCount: 1,
        hasRFID: true,
        image: null,
        brand: 'MBF SmartHome',
        model: 'MBF-SD-300',
        mcu: 'ESP32-WROVER',
        hardwareRevision: 'Rev C',
        serialNumber: 'SD300-2026-0117',
        macAddress: 'B4:E6:2D:1A:00:5C',
        ipAddress: '192.168.1.47',
        firmwareVersion: '1.4.2',
        connectionStatus: 'outdated',
        activatedAt: '2026-01-22',
        lastSyncAt: '2026-06-30 16:05'
    },
    {
        id: 'mbf-advanced-iot',
        name: 'MBF Advanced IoT Kit',
        sensorCount: 8,
        relayCount: 4,
        hasRFID: true,
        image: null,
        brand: 'MBF SmartHome',
        model: 'MBF-IOT-400',
        mcu: 'ESP32-S3 + RP2040',
        hardwareRevision: 'Rev A',
        serialNumber: 'IOT400-2026-0008',
        macAddress: 'B4:E6:2D:1A:00:83',
        ipAddress: '',
        firmwareVersion: '3.1.0',
        connectionStatus: 'offline',
        activatedAt: '2026-05-11',
        lastSyncAt: '2026-07-18 09:52'
    }
];

export default KITS;
